import { SvgIcon } from "@mui/material";
import { getIconSize } from "../bcp/BCPIcons";

export default function SquareIcon(props) {
  const { sx, style, color, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <SvgIcon
      sx={{
        ...sx,
        ...style,
        width: iconSize,
        height: iconSize,
      }}
      {...rest}
    >
      <svg
        version="1.1"
        id="Layer_1"
        viewBox="0 0 994.6 995.7"
        width={iconSize}
        height={iconSize}
        fill={color || style?.color || sx?.color || "#000000"}
      >
        <path
          class="st0"
          d="M828.4,0H166.2C74.4,0,0,74.4,0,166.2v662.2c0,91.8,74.4,166.2,166.2,166.2h662.2
			c91.8,0,166.2-74.4,166.2-166.2V166.2C994.6,74.4,920.2,0,828.4,0z M813.8,761.3c0,29-23.5,52.5-52.5,52.5h-528
			c-29,0-52.5-23.5-52.5-52.5v-528c0-29,23.5-52.5,52.5-52.5h528c29,0,52.5,23.5,52.5,52.5V761.3z M391.8,632.3
			c-16.7,0-30.1-13.5-30.1-30.2V391.3c0-16.7,13.4-30.3,30.1-30.3h211.1c16.6,0,30.1,13.5,30.1,30.3V602c0,16.7-13.5,30.2-30.1,30.2
			H391.8z"
          fill={color || style?.color || "currentColor"}
        />
      </svg>
    </SvgIcon>
  );
}
